<!-- Autocomplete Dropdown Component -->
<div 
  *ngIf="showDropdown && filteredOptions.length > 0" 
  class="autocomplete-dropdown" 
  [ngStyle]="dropdownStyle"
  (mousedown)="$event.preventDefault()"
>
  <ion-list>
    <ion-item 
      *ngFor="let option of filteredOptions" 
      (mousedown)="selectOption(option); $event.preventDefault()"
      button
      detail="false"
      class="autocomplete-item"
    >
      <ion-label>{{ option }}</ion-label>
    </ion-item>
  </ion-list>
</div>
